import { Injectable } from '@angular/core';
import { ContentPipe } from 'src/app/services/content/content.pipe';
import { EmployeeInfo } from 'src/app/api/models/employees/employees.intrface';
import { EmployeeAccountStatus } from 'src/app/api/models/data-mapping/data-mapping.enum';

@Injectable()
export class SystemsEmployeesTableCsvHelper {

    constructor(
        private contentPipe: ContentPipe
    ) {}
    
    getValueByKey(employee: EmployeeInfo, key: string): string {
        const values: Record<string, string> = {
            firstName: employee?.firstName ?? '-',
            lastName: employee?.lastName ?? '-',
            email: employee?.email ?? '-',
            status: this.getStatusText(employee?.accountInfo?.status)
        };
        return values[key];
    }

    private getStatusText(status: EmployeeAccountStatus): string {
        switch(status) {
            case(EmployeeAccountStatus.Active):
                return this.contentPipe.transform('employees.active');
            case(EmployeeAccountStatus.InActive): 
                return this.contentPipe.transform('employees.inActive');
            case(EmployeeAccountStatus.DeletedInWorkspace):
                return this.contentPipe.transform('employees.deleted');
            default:
                return '-';
        }
    }
}